import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import { ThemeSetup } from '../themes/ThemeSetup';

import './SearchField.css';
import t from '../i18n/I18n';

class SearchField extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func
  };

  static defaultProps = {
    placeholder: t('SEARCH') + '...'
  };

  render() {
    const { value, placeholder, onChange } = this.props;
    return (
      <div name="SearchField">
        <img className="search-icon" src={ThemeSetup.getImageURL('search.svg')} />
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          ref={(node) => (this._input = node)}
        />
        <Button
          icon={ThemeSetup.getImageURL('remove.svg')}
          className={(value || '').length ? 'visible' : ''}
          onClick={this.onClick}
        />
      </div>
    );
  }

  onClick = () => {
    this.props.onChange('');
    this._input.focus();
  };
}

export default SearchField;
